import { getTeamStatusClass } from "../ligaTV/cardPartido/statusHelpers";
import "./TeamPartido.sass";

/**
 * Componente TeamPartido - Renderiza la información de un equipo en la vista detallada del partido
 * 
 * @param {string} name - Nombre completo del equipo
 * @param {string} image - URL del logo del equipo
 * @param {string} statusClass - Clase de estado del equipo (winner, loser, draw)
 * @param {string} position - Posición del equipo: 'left' o 'right'
 */
export default function TeamPartido({
  name,
  image,
  statusClass,
  position = "left",
}) {
  return (
    <div className={`team-partido team-${position} ${getTeamStatusClass(statusClass)}`}>
      {/* Logo del equipo */}
      <div className="team-logo-partido">
        <img src={image} alt={name} title={name} />
      </div>

      {/* Información del equipo */}
      <div className="team-info-partido">
        <span className="team-full-name-partido">{name}</span>
      </div>
    </div>
  );
}